import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Checkbox({
  id,
  name = null,
  onChange = null,
  checked = false,
  disabled = false,
  children,
  className = null,
  value = '',
  ...otherProps
}) {
  const checkboxClasses = classNames('ws-checkbox', className, {
    'ws-checkbox--disabled': disabled,
  });

  return (
    <div className={checkboxClasses}>
      <label htmlFor={id} className="ws-checkbox__label">
        <input
          className="ws-checkbox__input"
          type="checkbox"
          id={id}
          name={name}
          onChange={onChange}
          defaultChecked={checked}
          disabled={disabled}
          value={value}
          {...otherProps}
        />
        <i className="ws-checkbox__checkmark" />
      </label>
      <div className="ws-checkbox__children">{children}</div>
    </div>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Checkbox;
